var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"items":_vm.tableData,"headers":_vm.headers,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.files",fn:function(ref){
var item = ref.item;
return [(item.files.length)?_c('FileList',{attrs:{"files":item.files}}):_c('div',[_vm._v("—")])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }